exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modebar{display:none!important}button{margin-right:10px}.hidden{display:none}", ""]);

// exports
